import { render, staticRenderFns } from "./EditImage.vue?vue&type=template&id=226e5b38&"
import script from "./EditImage.vue?vue&type=script&lang=js&"
export * from "./EditImage.vue?vue&type=script&lang=js&"
import style0 from "./EditImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports